import ManageSwr from '@/pages/ManageSwr';

export default {
    path: '/obsluga-swr',
    component: ManageSwr,
    name: 'manage-swr',
    meta: { requiresAuth: true }
};
